import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import Header from "../Components/Header";
import NavBar from "../Components/NavBar";
import useAuth from "../useAuth";
import { HiChevronRight } from "react-icons/hi";

export default function EntryPage() {
  const { user, menuOpen, changeMenuSize } = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="min-h-screen flex bg-white overflow-hidden font-outfit">
      {/* Sidebar Container */}
      <div
        className={`${menuOpen ? "w-72" : "w-20"
          } z-50 transition-all duration-500 ease-in-out fixed top-0 h-screen shadow-2xl sidebar-gradient`}
      >
        <NavBar />

        {/* Toggle Button - Premium Style */}
        <button
          onClick={changeMenuSize}
          className="absolute top-1/2 -right-3 w-8 h-12 bg-white text-indigo-600 flex items-center justify-center rounded-xl shadow-2xl border border-indigo-100/50 hover:bg-slate-50 transition-all duration-300 z-[60] !p-0"
        >
          <HiChevronRight
            className={`text-2xl transition-transform duration-500 ${menuOpen ? "rotate-180" : "rotate-0"}`}
          />
        </button>
      </div>

      {/* Main Content Area */}
      <div
        className={`${menuOpen ? "ml-72" : "ml-20"
          } transition-all duration-500 ease-in-out flex-1 flex flex-col h-screen overflow-hidden`}
      >
        <div className="z-40">
          <Header />
        </div>

        <main className="flex-1 overflow-y-auto fancy-scrollbar bg-white p-4 md:p-8">
          <div className="animate-in fade-in slide-in-from-bottom-4 duration-700">
            <Outlet />
          </div>


        </main>
      </div>
    </div>
  );
}

